import { useContext, useState, useEffect, useRef } from 'react';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';
import { WebApiContext } from 'ascendon-web-api';

function useStripePaymentList() {
  const [fault, setFault] = useState(null);
  const [uiModel, setUiModel] = useState('');
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const requestStripePaymentList = async ({ cdStripeHeader }) => {
    const envURL = ASCENDON_ENV_CONFIG.stripe.paymentListUrl;
    const paymentListEndPoint = 'payment/list';
    const customUrl = `${envURL}/${paymentListEndPoint}`;
    const headers =
      cdStripeHeader === 1
        ? {
            add: [{ name: 'CD-Stripe', value: cdStripeHeader }],
            remove: ['CD-SessionId'],
          }
        : {};

    WebApi.subscriber({
      forceRefresh: true,
      customUrl,
      headers,
      method: 'GET',
    })
      .then((response) => {
        if (isMounted.current) {
          const paymentListData = response.data;
          setUiModel(paymentListData);
        }
      })
      .catch((error) => {
        console.warn({ error });
        if (isMounted.current) {
          const code = error?.data?.Code;
          let errorMsg;
          if (!code) {
            const unknownFault = generateUnhandledFault(error.data);
            errorMsg = translateFault(unknownFault).translatedMessage;
            setFault(errorMsg);
          } else {
            errorMsg = translateFault(error.data).translatedMessage;
            setFault(errorMsg);
          }
        }
      });
  };

  return [uiModel, fault, requestStripePaymentList];
}

export { useStripePaymentList };
export default useStripePaymentList;
